import {
	type OrgRoleRecord,
	parseRoleKeys,
	resolveRoleKeyPermissions,
} from "./org-roles";
import { ENTITY_ROLE_PERMISSIONS, type EntityRoleKey } from "./roles";
import type { Permission } from "./statements";

export * from "./org-roles";
export * from "./roles";
export * from "./statements";

/**
 * Union of the permissions held through a member's org role(s), e.g. `"admin,reviewer_lead"`, given
 * the org's `OrganizationRole` rows for those keys (overrides and custom roles, D30).
 */
export function resolveOrgRolePermissions(
	role: string | null | undefined,
	orgRoles: readonly OrgRoleRecord[],
): Set<Permission> {
	const permissions = new Set<Permission>();
	for (const key of parseRoleKeys(role)) {
		for (const permission of resolveRoleKeyPermissions(key, orgRoles)) {
			permissions.add(permission);
		}
	}
	return permissions;
}

/** Content permissions an entity collaborator role grants on that entity. */
export function resolveEntityRolePermissions(
	role: EntityRoleKey | null | undefined,
): Set<Permission> {
	if (!role) {
		return new Set();
	}
	return new Set(
		ENTITY_ROLE_PERMISSIONS[role].map(
			(action) => `content:${action}` as Permission,
		),
	);
}
